export default "__VITE_ASSET__042b3e1f__"